var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBracketArrowEndGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13L10.5 13C10.2239 13 10 12.7761 10 12.5C10 12.2239 10.2239 12 10.5 12L11.5 12C12.3284 12 13 11.3284 13 10.5L13 2.5C13 1.67157 12.3284 0.999998 11.5 0.999998L10.5 0.999998C10.2239 0.999998 10 0.77614 10 0.499998C10 0.223856 10.2239 -2.23747e-06 10.5 -2.21333e-06L12 -2.08219e-06C13.1046 -1.98563e-06 14 0.895429 14 2L14 11C14 12.1046 13.1046 13 12 13Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83007 3.13921L9.86053 6.16392C10.0465 6.34953 10.0465 6.65047 9.86053 6.83608L6.83007 9.86079C6.64411 10.0464 6.3426 10.0464 6.15663 9.86079C5.97067 9.67518 5.97067 9.37424 6.15663 9.18863L8.37418 6.97529H0V6.02471H8.37418L6.15663 3.81137C5.97067 3.62576 5.97067 3.32482 6.15663 3.13921C6.3426 2.9536 6.64411 2.9536 6.83007 3.13921Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketArrowEndGrey);
export default __webpack_public_path__ + "static/media/bracket-arrow-end-grey.05642384af7721eb73690c611abd3e4c.svg";
export { ForwardRef as ReactComponent };